// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "6ce3272ccc89abd4","923": "09220781791f034c",}[chunkId] + ".js"
}